import React from 'react';
import { domain, partyBrands } from '../../common/config.js';
import { getColor, getImage, getTextColor } from '../../common/ThemeService.js';

const IMAGES_ARRAY = ['CALL_GREY.png', 'CALL_GREEN.png', 'CALL_RED.png', 'FOLD_GREY.png'
    , 'FOLD_GREEN.png', 'FOLD_RED.svg', 'RAISE_GREY.png', 'RAISE_GREEN.png', 'RAISE_RED.svg',
    'table.png', 'smiling.png', 'haha.png', 'angel.png', 'ok.png', 'evil.png', 'broken.png', 'whiz_ok.png',
    'Headphones.png', 'CupConfettiSmile.gif', 'WhizCryFull_Optmised.gif', 'WhizMicDrop_Optmised.gif',
    'Cards_Folded.png', 'Cards_In_Play.png'
]
const TROPHY = "/images/pokerQuiz/CupConfettiSmile.gif";
const AVG_SCORE = "/images/pokerQuiz/WhizMicDrop_Optmised.gif";
const BAD_SCORE = "/images/pokerQuiz/WhizCryFull_Optmised.gif";
const LEVEL_1 = "/images/pokerQuiz/level_1.gif";
const LEVEL_2 = "/images/pokerQuiz/level_2.gif";
const LEVEL_3 = "/images/pokerQuiz/level_3.gif";
const LEVEL_4 = "/images/pokerQuiz/level_4.gif";
const CARDS_IN_PLAY = 'Cards_In_Play.png';
const CARDS_FOLDED = 'Cards_Folded.png';

const QUIZ_ANSWER_IMAGES = {
    'call': {
        'gray': 'CALL_GREY.png',
        'green': 'CALL_GREEN.png',
        'red': 'CALL_RED.png'
    },
    'fold': {
        'gray': 'FOLD_GREY.png',
        'green': 'FOLD_GREEN.png',
        'red': 'FOLD_RED.svg'
    },
    'raise': {
        'gray': 'RAISE_GREY.png',
        'green': 'RAISE_GREEN.png',
        'red': 'RAISE_RED.svg'
    }
}

const RAISING_POSITIONS = {
    '0': {
        '3': ['Under the Gun', 'Big Blind', 'Small Blind']
    },
    '8': {
        '9': ['Small Blind'],
        '0': ['Button']
    },
    '9': {
        '0': ['Button', 'Big Blind']
    }
}
const POSITION_NAME = {
    '0': {
        'name': 'Button',
        'opponents': ['Cut Off', 'Under the Gun +1', 'Under the Gun', 'Big Blind', 'Small Blind'],
    },
    '1': {
        name: 'Cut Off',
        'opponents': ['Under the Gun +1', 'Under the Gun', 'Big Blind', 'Small Blind', 'Button']
    },
    '2': {
        name: 'Under the Gun +1',
        opponents: ['Under the Gun', 'Big Blind', 'Small Blind', 'Button', 'Cut Off']
    },
    '3': {
        name: 'Under the Gun',
        opponents: ['Big Blind', 'Small Blind', 'Button', 'Cut Off', 'Under the Gun +1'],
    },
    '8': {
        name: 'Big Blind',
        opponents: ['Small Blind', 'Button', 'Cut Off', 'Under the Gun +1', 'Under the Gun'],
    },
    '9': {
        name: 'Small Blind',
        opponents: ['Button', 'Cut Off', 'Under the Gun +1', 'Under the Gun', 'Big Blind']
    }
}
const DEFAULT_STATE = {
    page: 'quizTypes',
    quizResults: {},
    call: false,
    clickOn: 'none',
    currentQuestionIndex: 0,
    correctlyAnsCount: 0,
    attemptedCount: 0,
    questions: [],
    positionNumber: [],
    facingPositionNumber: [],
    commonMessage: {},
    answerMessage: {},
    status: 2,
    cards: [],
    heroPosition: 0,
    loading: false,
    card1Loading: true,
    card2Loading: true,
    quizSubmitStatus: false,
    currentQuizType: {},
    currentQuiz: '',
    foldImage: QUIZ_ANSWER_IMAGES.fold.gray,
    raiseImage: QUIZ_ANSWER_IMAGES.raise.gray,
    callImage: QUIZ_ANSWER_IMAGES.call.gray,
    facingRaiserPosition: -1,
    questionsLoaded: false,
    currentFacingPosition: -1,
    intervalId: '',
    quizScenarioSteps: {
    },
    stepCount: 0,
    potSize: undefined,
    flopCards: undefined,
    betSize: undefined,
    bb: undefined
}
const LOADER = () => {
    return <div className="quiz-loader-div">
        <div className="quiz-loader"></div>
    </div>
}
const Chip = (props) => {
    let bb = props.bb ? props.bb : '0.02';
    let sb = props.bb ? props.bb / 2 : '0.01';
    return <div className={props.className ? "" : "quiz_chip_div"} style={{ ...props.styles }}>
        <img style={{
            height: '8px',
            width: '12.31px',
            top: '10px',
            position: 'relative',
            ...props.imgStyle

        }}
        alt="bet"
            src={"//" + domain + "/images/handReplay/chips/chip 10@2x.png "}></img>
        {<span className="quiz_chip_currency"> {props.value ? '$' + props.value : props.positionName === 'Big Blind' ?
            '$' + (props.initialData ? props.initialData.bigBlindValue : bb) :
            '$' + (props.initialData ? props.initialData.smallBlindValue : sb)}</span>}

    </div>
}
const OpponentsDivCreation = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    return <div className="opponents-img-div" style={{ ...props.style }}>
        {props.opponents.map((opponent, index) => {

            let facingIndex = props.facingRaiser ? props.facingRaiser.findIndex((item) => item === opponent.positionName) : -1;
            return <div key={index} style={{ ...opponent.styles }}>
                <div>
                    <div className='oppenent_and_cards_div' style={opponent.play_fold_cards ? { flexDirection: 'row-reverse' } : { flexDirection: 'row' }}>
                        <img src={"//" + domain + opponent.img} 
                        alt="opponentImg"
                        style={props.facingRaiser ?
                            props.facingRaiser.includes(opponent.positionName) ? {} : { filter: 'opacity(0.6)' } : {}}></img>
                        {props.facingRaiser ?
                            (props.facingRaiser.includes(opponent.positionName) ?
                                <img className='in-play-fold-cards'
                                alt="card"
                                    style={opponent.play_fold_cards ? { marginRight: '-12px' } : { marginLeft: '-15px' }} src={"//" + domain + "/images/pokerQuiz/" + CARDS_IN_PLAY}></img> :
                                <img className='in-play-fold-cards'
                                alt="card"
                                    style={opponent.play_fold_cards ? { marginRight: '-12px' } : { marginLeft: '-15px' }}
                                    src={"//" + domain + "/images/pokerQuiz/" + CARDS_FOLDED}></img>) : null}
                    </div>
                    <div className="opponent_description-div" style={{ ...opponent.opponentStyle }}>
                        <div className="opponent_description">
                            <p>{opponent.opponentName}</p>
                            <p>{opponent.bet}</p>
                        </div>
                        {opponent.positionName === 'Button' && <img className="button-dollar" alt="buttonDollar" src={"//" + domain + getImage("/images/pokerQuiz/","/dealerBtn.svg")}></img>}
                    </div>
                    <div className="opponent_position"
                        style={{
                            backgroundColor: themeColor,
                            color: themeTextColor,
                        }}
                    >
                        {opponent.positionName}
                    </div>
                </div>
                {(['Big Blind', 'Small Blind'].includes(opponent.positionName) && !props.facingRaiser) || (props.facingRaiser &&
                    facingIndex !== -1) ? <Chip positionName={opponent.positionName}
                        value={props.facingRaiser &&
                            facingIndex === 0 ? props.value : undefined}
                        bb={props.bb}
                        styles={opponent.chipStyle} /> : null}
            </div>
        }
        )}
    </div>
}

const QuizScenarioOpponentsDivCreation = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const doesFlop = (props.currentStepObj && props.currentStepObj.key === 'flop') || props.stepsCompleted['flop'];
    return <div className="opponents-img-div" style={{ ...props.style }}>
        {props.opponents.map((opponent, index) => {
            const stepObj = props.currentStepObj && props.currentStepObj.key === opponent.opponentName ? props.currentStepObj : props.stepsCompleted[opponent.opponentName];
            const currentStep = props.currentStepObj && props.currentStepObj.key === opponent.opponentName ? props.currentStepObj : undefined
            return <div key={index} style={{ ...opponent.styles }}>
                <div>
                    <div className='oppenent_and_cards_div' style={opponent.play_fold_cards ? { flexDirection: 'row-reverse' } : { flexDirection: 'row' }}>
                        <img alt="card" style={!stepObj || stepObj.action !== 'fold' ? {} : { filter: 'opacity(0.6)' }} src={"//" + domain + opponent.img}></img>
                        {!stepObj || stepObj.action !== 'fold' ?
                            <img className='in-play-fold-cards'
                            alt="in-play-fold-cards"
                                style={opponent.play_fold_cards ? { marginRight: '-12px' } : { marginLeft: '-15px' }} src={"//" + domain + "/images/pokerQuiz/" + CARDS_IN_PLAY}></img> :
                            <img className='in-play-fold-cards'
                            alt="in-play-fold-cards"
                                style={opponent.play_fold_cards ? { marginRight: '-12px' } : { marginLeft: '-15px' }}
                                src={"//" + domain + "/images/pokerQuiz/" + CARDS_FOLDED}></img>}
                    </div>
                    <div className="opponent_description-div" style={{ ...opponent.opponentStyle }}>
                        <div className="opponent_description">
                            <p>{opponent.opponentName}</p>
                            <p>{currentStep && currentStep.action ? currentStep.action : opponent.bet}</p>
                        </div>
                        {opponent.positionName === 'Button' && <img className="button-dollar" alt="buttonDollar" src={"//" + domain + getImage("/images/pokerQuiz/", "/dealerBtn.svg")}></img>}
                    </div>
                    <div className="opponent_position"
                        style={{
                            backgroundColor: themeColor,
                            color: themeTextColor,
                        }}>
                        {opponent.positionName}
                    </div>
                </div>
                {(!doesFlop || (currentStep && currentStep.action !== 'flop' && currentStep.value))
                    && (['Big Blind', 'Small Blind', ''].includes(opponent.positionName)
                        || (stepObj && stepObj.action !== 'fold' && stepObj.value))
                    && (!stepObj || (stepObj.action !== 'fold' && stepObj.value)) ? <Chip positionName={opponent.positionName}
                        value={stepObj && stepObj.value}
                        initialData={props.initialData}
                        styles={opponent.chipStyle} /> : null}
            </div>
        }
        )}
    </div>
}
const QuizPositions = (props) => {
    let oppenentArray = [{
        elements:
            [{
                className: '',
                chipStyle: { top: '15px' },
                styles: { marginTop: '-40px' },
                opponentName: 'Opponent 3',
                bet: '$2.00',
                positionName: POSITION_NAME[props.heroPosition].opponents[2],
                img: "/images/pokerQuiz/smiling.png"
            }],
        style: { justifyContent: 'center', marginBottom: '0px' },
        play_fold_cards: true
    },
    {
        elements: [{
            className: '"opponent_description"',
            styles: { display: 'flex' },
            opponentName: 'Opponent 2',
            bet: '$2.00',
            positionName: POSITION_NAME[props.heroPosition].opponents[3],
            img: "/images/pokerQuiz/haha.png",
            play_fold_cards: false
        },
        {
            className: '"opponent_description"',
            chipStyle: { flexDirection: 'row-reverse', left: '-10px' },
            opponentStyle: { flexDirection: 'row-reverse' },
            styles: { display: 'flex', flexDirection: 'row-reverse' },
            img: "/images/pokerQuiz/angel.png",
            opponentName: 'Opponent 4',
            bet: '$2.00',
            positionName: POSITION_NAME[props.heroPosition].opponents[1],
            play_fold_cards: true
        }
        ]
    }, {
        elements: [{
            img: "/images/pokerQuiz/ok.png",
            className: '"opponent_description"',
            styles: { display: 'flex' },
            opponentName: 'Opponent 1',
            bet: '$2.00',
            positionName: POSITION_NAME[props.heroPosition].opponents[4],
            play_fold_cards: false
        },
        {
            img: "/images/pokerQuiz/evil.png",
            className: '"opponent_description"',
            chipStyle: { flexDirection: 'row-reverse', left: '-10px' },
            styles: { display: 'flex', flexDirection: 'row-reverse' },
            opponentStyle: { flexDirection: 'row-reverse' },
            opponentName: 'Opponent 5',
            bet: '$2.00',
            positionName: POSITION_NAME[props.heroPosition].opponents[0],
            play_fold_cards: true
        }
        ]
    }
    ]
    return <div className="opponents-main-div">
        {oppenentArray.map((opponentsObj, index) => <OpponentsDivCreation key={index}
            opponents={opponentsObj.elements} style={opponentsObj.style}
            bb={props.bb}
            value={props.betSize}
            facingRaiser={RAISING_POSITIONS[props.heroPosition] ? RAISING_POSITIONS[props.heroPosition][props.facingRaiserPosition] : false}
        />)}
    </div>
}

const AnswerOptionsComp = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    return <div className="answer-options-main-div">
        <div className="answer-options">
            <img className={props.call ? 'fold_raise_zoom_img' : ''}
            alt="fold"
                src={"//" + domain + "/images/pokerQuiz/" + props.foldImage}
                onClick={() => props.status === 2 ? props.onAnswerClick('fold') : {}}
            ></img>
            <img src={"//" + domain + "/images/pokerQuiz/" + props.callImage}
             alt="call"
                onClick={() => props.status === 2 ? props.onAnswerClick('call') : {}}></img>
            <img
                className={props.call ? 'fold_raise_zoom_img' : ''}
                alt="raise"
                src={"//" + domain + "/images/pokerQuiz/" + props.raiseImage}
                onClick={() => props.status === 2 ? props.onAnswerClick('raise') : {}}
            ></img>
        </div>

        {POSITION_NAME[props.heroPosition].name === 'Button' && <img 
         alt="pp"
        style={{
            width: '15px', height: 'auto',
            position: 'relative', left: '95px'
        }} src={"//" + domain + getImage("/images/pokerQuiz/","/dealerBtn.svg")}></img>}
        {props.status !== 2 && <div className="next_position"
            style={POSITION_NAME[props.heroPosition].name !== 'Button' ? {
                marginTop: '32px',
                backgroundColor: themeColor,
                color: themeTextColor,
            } : {
                backgroundColor: themeColor,
                color: themeTextColor,
            }}
            onClick={props.onNext}>
            NEXT
    </div>}
        {props.status === 2 && <div className="quiz-cards" style={POSITION_NAME[props.heroPosition].name !== 'Button' ? { paddingTop: '18px' } : {}}>
            {(props.card1Loading || props.card2Loading) && <div>
                <i className="fa fa-2x fa-spinner fa-pulse" style={{ color: 'white' }}></i>
                <i className="fa fa-2x fa-spinner fa-pulse" style={{ color: 'white' }}></i>
            </div>}
            {props.cards.map((card, index) =>
                <img key={index}
                alt="gameCard"
                    onLoad={() => props.onLoad(index)}
                    style={{ display: (props.card1Loading || props.card2Loading) ? 'none' : 'inline' }}

                    src={"//" + domain + `/images/handReplay/cards/${card.replace(/^./, card[0].toUpperCase())}.png`}></img>
            )}
            {['Big Blind', 'Small Blind'].includes(POSITION_NAME[props.heroPosition].name) && <Chip positionName={POSITION_NAME[props.heroPosition].name}
                className="className"
                bb={props.bb}
                styles={{ position: 'relative', left: '99px', top: '-104px' }} />}
        </div>}

        {props.status === 2 && <div className="hero_position" style={['Big Blind', 'Small Blind'].includes(POSITION_NAME[props.heroPosition].name) ? {
            marginTop: '-18px',
            backgroundColor: themeColor,
            color: themeTextColor,
        } : {
            marginTop: '2px',
            backgroundColor: themeColor,
            color: themeTextColor,
        }}>
            {POSITION_NAME[props.heroPosition].name}
        </div>}
    </div>
}
const QuizScenarioHeroDetails = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const currentStepObj = props.currentStepObj && props.currentStepObj.key === 'Hero' ? props.currentStepObj : props.stepsCompleted['Hero'];
    const currentStep = props.currentStepObj && props.currentStepObj.key === 'Hero' ? props.currentStepObj : undefined
    const doesFlop = (props.currentStepObj && props.currentStepObj.key === 'flop') || props.stepsCompleted['flop'];
    return <div className="answer-options-main-div" style={{ bottom: '55px' }}>
        {POSITION_NAME[props.heroPosition].name === 'Button' && <img 
        alt="pp"
        style={{
            width: '15px', height: 'auto',
            position: 'relative', left: '95px'
        }} src={"//" + domain + getImage("/images/pokerQuiz/","/dealerBtn.svg")}></img>}
        {(!doesFlop || (currentStep && currentStep.action !== 'flop' && currentStep.value))
            && (['Big Blind', 'Small Blind'].includes(POSITION_NAME[props.heroPosition].name)
                || (currentStepObj && currentStepObj.action !== 'fold' && currentStepObj.value))
            && (!currentStepObj || (currentStepObj.action !== 'fold' && currentStepObj.value)) ?
            <Chip positionName={POSITION_NAME[props.heroPosition].name}
                className="className"
                value={currentStepObj && currentStepObj.value}
                initialData={props.initialData}
                imgStyle={{ top: '-4px', left: '52px' }}
                styles={{ position: 'relative' }} /> : null}
        <div className="opponent_description-div" style={{ justifyContent: 'center' }} >
            <div className="opponent_description"  >
                <p>{'You'}</p>
                <p>{currentStep && currentStep.action ? currentStep.action : '$' + props.amount}</p>
            </div>
            {POSITION_NAME[props.heroPosition].name === 'Button' && <img className="button-dollar" alt="buttonDollar" src={"//" + domain + getImage("/images/pokerQuiz/","/dealerBtn.svg")}></img>}
        </div>
        {<div className="quiz-cards" style={POSITION_NAME[props.heroPosition].name !== 'Button' ? { paddingTop: '18px' } : {}}>
            {props.cards.map((card, index) =>
                <img key={index}
                alt="gameCard"
                    style={{ display: (props.card1Loading || props.card2Loading) ? 'none' : 'inline' }}
                    src={"//" + domain + `/images/handReplay/cards/${card.replace(/^./, card[0].toUpperCase())}.png`}></img>
            )}
        </div>}
        <div className="hero_position" style={{
            marginTop: '2px', backgroundColor: themeColor,
            color: themeTextColor
        }}>
            {POSITION_NAME[props.heroPosition].name}
        </div>
    </div>
}
const QuizStaticPositions = (props) => {
    let oppenentArray = [{
        elements:
            [{
                className: '',
                chipStyle: { top: '15px' },
                styles: { marginTop: '-40px' },
                opponentName: 'Opponent 3',
                bet: '$2.00',
                positionName: POSITION_NAME[props.heroPosition].opponents[2],
                img: "/images/pokerQuiz/smiling.png"
            }],
        style: { justifyContent: 'center', marginBottom: '0px' },
        play_fold_cards: true
    },
    {
        elements: [{
            className: '"opponent_description"',
            styles: { display: 'flex' },
            opponentName: 'Opponent 2',
            bet: '$2.00',
            positionName: POSITION_NAME[props.heroPosition].opponents[3],
            img: "/images/pokerQuiz/haha.png",
            play_fold_cards: false
        },
        {
            className: '"opponent_description"',
            chipStyle: { flexDirection: 'row-reverse', left: '-10px' },
            opponentStyle: { flexDirection: 'row-reverse' },
            styles: { display: 'flex', flexDirection: 'row-reverse' },
            img: "/images/pokerQuiz/angel.png",
            opponentName: 'Opponent 4',
            bet: '$2.00',
            positionName: POSITION_NAME[props.heroPosition].opponents[1],
            play_fold_cards: true
        }
        ]
    }, {
        elements: [{
            img: "/images/pokerQuiz/ok.png",
            className: '"opponent_description"',
            styles: { display: 'flex' },
            opponentName: 'Opponent 1',
            bet: '$2.00',
            positionName: POSITION_NAME[props.heroPosition].opponents[4],
            play_fold_cards: false
        },
        {
            img: "/images/pokerQuiz/evil.png",
            className: '"opponent_description"',
            chipStyle: { flexDirection: 'row-reverse', left: '-10px' },
            styles: { display: 'flex', flexDirection: 'row-reverse' },
            opponentStyle: { flexDirection: 'row-reverse' },
            opponentName: 'Opponent 5',
            bet: '$2.00',
            positionName: POSITION_NAME[props.heroPosition].opponents[0],
            play_fold_cards: true
        }
        ]
    }
    ]
    return <div className="opponents-main-div">
        {oppenentArray.map((opponentsObj, index) => <QuizScenarioOpponentsDivCreation key={index}
            currentStep={props.currentStep}
            initialData={props.initialData}
            opponents={opponentsObj.elements} style={opponentsObj.style}
            currentStepObj={props.currentStepObj}
            stepsCompleted={props.stepsCompleted}
            facingRaiser={RAISING_POSITIONS[props.heroPosition] ? RAISING_POSITIONS[props.heroPosition][props.facingRaiserPosition] : false}
        />)}
    </div>
}
const FlopCards = (props) => {
    return <div className="quiz-scenario-flop-div">
        {<div className="quiz-scenario-flop-cards">
            {props.cards.map((card, index) =>
                <img key={index}
                alt="flopCard"
                    // onLoad={() => props.onLoad(index)}
                    style={{ display: 'inline' }}
                    src={"//" + domain + `/images/handReplay/cards/${card.replace(/^./, card[0].toUpperCase())}.png`}></img>
            )}
        </div>}

        <span className="quiz_chip_currency" style={{ marginTop: '15px', marginLeft: '10px' }}>
            {"$" + props.value}
        </span>

    </div>
}
const viewScenariosIntro = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const elems = [];
    elems.push(<i key="viewScenarioGoback" className="fa fa-lg fa-long-arrow-left cursor-pointer quiz-back-button"
        data-e2e="back-button" style={{ fontSize: "24px", position: 'absolute', left: '20px', color: themeColor }}
        onClick={() => props.goBack('quizSubTypes')}
    ></i>);
    elems.push(<img key="viewScenariosImg" alt="viewScenariosImg" className="quiz-img" src={"//" + domain +(partyBrands.includes(localStorage.getItem("loggedInType"))? "/images/pokerQuiz/SmileFlickingCapUp.gif":"/images/pokerQuiz/SmileFlickingCapUp_generic.gif")}></img>);
    elems.push(<div key="viewScenariosTitle" className="title">{props.type}</div>)
    elems.push(<div key="viewScenariosDescription" className="description">{props.description}</div>)
    elems.push(<button key="viewScenariosQuizbtn" className="partyPokerPlayBtn quiz-button"
        data-e2e="view-scenario" onClick={() => props.playScenario(props.currentQuiz)}
        style={{
            backgroundColor: themeColor,
            color: themeTextColor,
            borderColor: themeColor,
        }}
        >
        <span >
            VIEW SCENARIO
        </span>
    </button>)
    elems.push(<button key="viewScenariosSkipbtn" className="skipButton"
        data-e2e="skip-scenario" onClick={props.startQuiz}>
        <span >
            Skip
    </span>
    </button>)
    return elems;
}
const getQuizScenarios = (props) => {
    const themeColor = getColor()
    const elems = [];
    let currentStep = props.quizScenarios.steps[props.currentStep];
    const currentStepObj = currentStep && currentStep.key === 'flop' ? currentStep : props.stepsCompleted['flop'];
    elems.push(<i key="playScenarioGoback" className="fa fa-lg fa-long-arrow-left cursor-pointer quiz-back-button"
        data-e2e="back-button" style={{ fontSize: "24px", position: 'absolute', left: '20px', color: themeColor }}
        onClick={() => props.goBack('viewScenarios')}
    ></i>);
    elems.push(<div className="quiz-table-div" key="quiz-table-div"
        style={{ backgroundImage: `url(https://${domain}/images/pokerQuiz/table.png)` }}>
        <QuizStaticPositions heroPosition={props.quizScenarios.intialData.heroPosition}
            stepsCompleted={props.stepsCompleted}
            currentStep={props.currentStep}
            currentStepObj={currentStep}
            initialData={props.quizScenarios.intialData}
        />
        <QuizScenarioHeroDetails
            heroPosition={props.quizScenarios.intialData.heroPosition}
            stepsCompleted={props.stepsCompleted}
            cards={props.quizScenarios.intialData.cards}
            amount={props.quizScenarios.intialData.amount}
            currentStepObj={currentStep}
            initialData={props.quizScenarios.intialData}
        />
    </div>);
    elems.push(
        <div className="quiz-scenario-hero-div" key="quiz-scenario-hero-div">
            <div>
                {props.currentStep > 0 && <i className="fa fa-long-arrow-left"
                    onClick={props.goToPrevScenario} style={{ color: themeColor }}></i>}
            </div>
            <div className="quiz-scenario-message">
                <p>{currentStep.message}</p>
            </div>
            <div>
                {props.currentStep < props.quizScenarios.steps.length && <i className="fa fa-long-arrow-right"
                    onClick={props.goToNextScenario}
                    style={{ color: themeColor }}></i>}
            </div>
        </div>)
    if (currentStepObj) {
        elems.push(<FlopCards key="flp_cards" cards={currentStepObj.cards} value={currentStepObj.value} />)
    }
    return elems;
}

const getQuizTypeComp = (props) => {
    const themeColor = getColor()
    const elems = [];
    elems.push(
        <div className="quiz-content-type-header" key={'quizTypes'}>
            Select quiz type</div>)
    if (props.quizDetails && props.quizDetails.length > 0) {
        props.quizDetails.map((item, key) => {
           return elems.push(
                <div key={key} className="quiz-content-quiz-type-div" onClick={() => props.getQuizes(item)}>
                    <div className="quiz-content-quiz-type" >
                        {item.name}
                    </div>
                   <div className="chevron-red-color" style={{
                       color: themeColor,
                   }} >
                        <i className="fa fa-chevron-right"></i>
                    </div>
                </div>
            )
        })

    } else {
        elems.push(<div className="quiz-loader-div" key={'quizTypes-loader'}>
            <div className="quiz-loader"></div>
        </div>)
    }
    return elems;
}
const getQuizSubTypeComp = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const elems = [];
    elems.push(
        <div className="quiz-content-subtype-header" key={'quizSubTypes'}>
            <i className="fa fa-lg fa-long-arrow-left cursor-pointer quiz-back-button"
                style={{
                    color: themeColor,
                }}
                data-e2e="back-button" style={{ fontSize: "18px",  color: themeColor }}
                onClick={() => props.goBack('quizTypes')}
            ></i>
            {props.currentQuizType.name}
        </div>)
    if (props.quizDetails && props.quizDetails.meta && props.quizDetails.meta.length > 0) {
        props.quizDetails.meta.map((item, key) => {
            let userBest = props.quizDetails.userBest && props.quizDetails.userBest.find((data) => data._id === item._id)
           return elems.push(
                <div key={key} className="quiz-content-quiz-sub-type-div">
                    <div className="quiz-content-quiz-sub-type" >
                        {item.type}
                    </div>
                    <div className="quiz-content-quiz-sub-type-header" >
                        {userBest ? 'Personal best: ' + (userBest.correctAnswersCount >= userBest.totalQuizQuestions ? userBest.totalQuizQuestions : userBest.correctAnswersCount) + '/' + userBest.totalQuizQuestions : 'Unplayed'}
                    </div>
                   <div className="quiz-play-button" style={{
                       backgroundColor: themeColor,
                       color: themeTextColor,
                   }} onClick={() => props.playQuiz(item)}>
                        Play Now!
                        </div>
                </div>
            )
        })

    } else {
        elems.push(<div className="quiz-loader-div" key={'quizTypes-loader'}>
            <div className="quiz-loader"></div>
        </div>)
    }
    return elems;
}

export {
     DEFAULT_STATE,
    getQuizTypeComp,  POSITION_NAME,
    QUIZ_ANSWER_IMAGES, IMAGES_ARRAY, QuizPositions, AnswerOptionsComp, TROPHY, AVG_SCORE,
    BAD_SCORE, LOADER, getQuizSubTypeComp, getQuizScenarios,
    FlopCards, viewScenariosIntro,
    LEVEL_1, LEVEL_2, LEVEL_3, LEVEL_4
}


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/QuickQuizHelper.js
 **/